import React from "react";
import { Header } from "semantic-ui-react";
import PropTypes from "prop-types";
import NoDocs from "./no-docs";

const ApiDocumentation = ({ children }) => {
  if (!children) {
    return <NoDocs />;
  }
  return (
    <>
      <Header as="h2">API Documentation</Header>
      {children}
    </>
  );
};

ApiDocumentation.propTypes = {
  children: PropTypes.node,
};

export default ApiDocumentation;
